import Midjourney from "../components/Midjourney";
 

export const MidjourneyRoutes =[
    {
        path:"/midjourney",
        element: <Midjourney/>
    },
   
];

 